var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('AppModal',{staticClass:"flex justify-center w-full text-tundora",attrs:{"heading":false,"width-class":"w-68"},on:{"close":_vm.onModalClose}},[_c('div',[_c('CustomerSearch',{attrs:{"on-close":_vm.onModalClose}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }